import { render } from "./ProjectSectionAddons.vue?vue&type=template&id=5b25aa2e"
import script from "./ProjectSectionAddons.vue?vue&type=script&lang=js"
export * from "./ProjectSectionAddons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__